import type { ReactElement } from 'react'

const SkeletonAvatar = (): ReactElement => (
    <div className="skeleton-pulse-legacy h-[35px] w-[35px] min-w-[35px] rounded-full" />
)

export default SkeletonAvatar
